document.addEventListener('DOMContentLoaded', function() {
  const bisWidget = document.getElementById('sealapps-bis-widget');
  const cartWishlistWrap = document.querySelector('.cart-wishlist-wrap');

  if (bisWidget && cartWishlistWrap) {
    const wrapper = document.createElement('div');
    if(document.querySelector('body').classList.contains('template-product')){
      wrapper.classList.add('bis-widget-wrapper');
    }else {
      wrapper.style.width = '100%';
      wrapper.style.display = 'flex';
      wrapper.style.justifyContent = 'center';
      wrapper.style.marginTop = '4px';
      wrapper.style.marginBottom = '24px';
    }

    wrapper.appendChild(bisWidget);
    cartWishlistWrap.parentNode.insertBefore(wrapper, cartWishlistWrap.nextSibling);
  }
});
